// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { EnumAttachmentType } from '../../../../../com/MetaPattern/MDA/MD/Base/EnumAttachmentType';
import { APP } from './APP';
/**
 * 附件文件 实体类
 * 应用或组件的附件文件
 */
export class AttachmentFile extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 文件名 : 文件的客户端名称，可重名 */
  private _filename: string;

  /** 设置：文件名 */
  public get filename() {
    return this._filename;
  }

  /** 获取：文件名 */
  public set filename(value: string) {
    this._filename = value;
  }

  /** 文件存放路径 : 文件存放路径 */
  private _fileURL: string;

  /** 设置：文件存放路径 */
  public get fileURL() {
    return this._fileURL;
  }

  /** 获取：文件存放路径 */
  public set fileURL(value: string) {
    this._fileURL = value;
  }

  /** 附件类型 : 附件类型 */
  private _attachmentType: EnumAttachmentType;

  /** 设置：附件类型 */
  public get attachmentType() {
    return this._attachmentType;
  }

  /** 获取：附件类型 */
  public set attachmentType(value: EnumAttachmentType) {
    this._attachmentType = value;
  }

  /** 执行顺序号 : 执行顺序号，越小的执行越靠前 */
  private _sequence: number;

  /** 设置：执行顺序号 */
  public get sequence() {
    return this._sequence;
  }

  /** 获取：执行顺序号 */
  public set sequence(value: number) {
    this._sequence = value;
  }

  /** 所属应用 的ID */
  private _aPP_ID: string;

  /** 获取：所属应用 的ID */
  public get aPP_ID() {
    return this._aPP_ID;
  }

  /** 设置：所属应用 的ID */
  public set aPP_ID(value: string) {
    this._aPP_ID = value;
  }

  /** 所属应用  */
  private _aPP: APP;

  /** 获取：所属应用  */
  public get aPP() {
    return this._aPP;
  }

  /** 设置：所属应用  */
  public set aPP(value: APP) {
    this._aPP = value;
    if (value !== null) {
      this.aPP_ID = value.id;
    } else {
      this.aPP_ID = '';
    }
  }

  constructor() {
    super();
    this._name = '';
    this._filename = '';
    this._fileURL = '';
    this._attachmentType = EnumAttachmentType.SQLScript;
    this._sequence = 0;
    this._aPP_ID = '';
    this._aPP = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: AttachmentFile, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.filename = element.filename;
      this.fileURL = element.fileURL;
      this.attachmentType = element.attachmentType;
      this.sequence = element.sequence;
      this.aPP_ID = element.aPP_ID;
      if (hasReference && element.aPP !== null) {
        this.aPP = element.aPP;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.filename = json.Filename;
    this.fileURL = json.FileURL;
    this.attachmentType = json.AttachmentType as EnumAttachmentType;
    this.sequence = json.Sequence;
    this.aPP_ID = json.APP_ID;
    // if (json.APP !== null) {
    //   this.aPP = APP.Create(json.APP);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Filename = this.filename;
    json.FileURL = this.fileURL;
    json.AttachmentType = this.attachmentType;
    json.Sequence = this.sequence;
    json.APP_ID = this.aPP_ID;
  }

  static Create(json: any): AttachmentFile {
    const attachmentFile = new AttachmentFile();
    attachmentFile.Deserialize(json);
    attachmentFile.json = json;
    return attachmentFile;
  }
}
